import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomeCompareFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m18.37 17.41-6.53-6.12a2 2 0 0 0-2.74 0l-6.47 6.12A2 2 0 0 0 2 18.86V28a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-9.13a2 2 0 0 0-.63-1.46m-3.75 3.37-5 4A1 1 0 0 1 9 25a1 1 0 0 1-.71-.29l-2-2a1 1 0 0 1 1.42-1.42l1.36 1.37 4.31-3.44a1 1 0 1 1 1.24 1.56M29.35 6.17l-4.18-3.9a1 1 0 0 0-1.34 0l-4.18 3.9A2.1 2.1 0 0 0 19 7.69V14a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V7.69a2.1 2.1 0 0 0-.65-1.52m-2.23 3.61-2.5 2A1 1 0 0 1 24 12a1 1 0 0 1-.71-.29l-1-1a1 1 0 0 1 1.42-1.42l.36.37 1.81-1.44a1 1 0 1 1 1.24 1.56" />
  </svg>
);
const ForwardRef = forwardRef(IconHomeCompareFilledSVG);
ForwardRef.displayName = "IconHomeCompareFilled";
export { ForwardRef as IconHomeCompareFilled };
